import React from 'react';

function Redirect(props) {
    return (
        <div>
            <h1>
                Redirecting...
            </h1>
            <br />
            <h1> or click <a href={'https://www.pqeconference.com/'}>Here</a></h1>
        </div>
    );
}

export default Redirect;